import EmblaCarousel from "embla-carousel";
import {
  addThumbBtnsClickHandlers,
  addToggleThumbBtnsActive,
} from "./embla/emblaControls.js";

const OPTIONS = {};
const OPTIONS_THUMBS = {
  containScroll: "keepSnaps",
  dragFree: true,
};

const viewportNodeMainCarousel = document.querySelector(
  ".emblaGallery .embla__viewport"
);
if (!viewportNodeMainCarousel) return;

const viewportNodeThumbCarousel = document.querySelector(
  ".emblaGallery .embla-thumbs__viewport"
);

console.log(viewportNodeMainCarousel, viewportNodeThumbCarousel);
const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS);
const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS);

const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
  emblaApiMain,
  emblaApiThumb
);
const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
  emblaApiMain,
  emblaApiThumb
);

emblaApiMain
  .on("destroy", removeThumbBtnsClickHandlers)
  .on("destroy", removeToggleThumbBtnsActive);
